import Icons, { SvgIconProps } from '../Icons';

export default function (props: SvgIconProps) {
  return (
    <Icons {...props} viewBox="0 0 32 32">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
        <path
          d="M1.625 16C1.15833 16 0.771 15.846 0.463 15.538C0.154333 15.2293 0 14.8417 0 14.375V1.625C0 1.15833 0.154333 0.771 0.463 0.463C0.771 0.154333 1.15833 0 1.625 0H16.375C16.8417 0 17.2293 0.154333 17.538 0.463C17.846 0.771 18 1.15833 18 1.625V14.375C18 14.8417 17.846 15.2293 17.538 15.538C17.2293 15.846 16.8417 16 16.375 16H1.625ZM1.625 15H16.375C16.5417 15 16.6873 14.9373 16.812 14.812C16.9373 14.6873 17 14.5417 17 14.375V1.625C17 1.45833 16.9373 1.31267 16.812 1.188C16.6873 1.06267 16.5417 1 16.375 1H1.625C1.45833 1 1.31267 1.06267 1.188 1.188C1.06267 1.31267 1 1.45833 1 1.625V14.375C1 14.5417 1.06267 14.6873 1.188 14.812C1.31267 14.9373 1.45833 15 1.625 15ZM2.5 12.5H6.5V11.5H2.5V12.5ZM11.55 10.3L15.8 6.05L15.075 5.325L11.55 8.875L10.125 7.45L9.425 8.175L11.55 10.3ZM2.5 8.5H6.5V7.5H2.5V8.5ZM2.5 4.5H6.5V3.5H2.5V4.5Z"
          fill="#212121"
        />
      </svg>
    </Icons>
  );
}
